// Tab1.js
import { useTheme as useAppTheme } from '../../contexts/ThemeContext';
import React from 'react';
import { useState } from "react";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Autocomplete from "@mui/material/Autocomplete";
import useMediaQuery from "@mui/material/useMediaQuery";
import { styled } from "@mui/material/styles";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from '@mui/material/Tooltip';
import Table from "@mui/material/Table";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import { useEffect, useRef } from "react";
import { Card, Button, Grid, TextField, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import { ButtonGroup } from "@mui/material";
import { DialogContentText } from '@mui/material';
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Menu from '@mui/material/Menu';
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
    createTrainerPackage,retrieveTrainerPackage,AutocompleteTrainerPackage,UpdateTrainerPackage,DeleteTrainerPackage,StatusTrainerPackage
  } from "../Apihelper/ApiHelper";
import json2mq from "json2mq";
import AppToast from '../../components/Toast/AppToast';
const PtPackage = (props) => {
  const { colors: appColors } = useAppTheme();
    const [hasMore, setHasMore] = useState(true);
    const [inputValue, setInputValue] = useState('');
    const [options, setOptions] = useState([]);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success'); // Default to 'success'
    const [fetchdatarow, setetchdatarow] = useState([]); // Default to 'success'
    const [index, setIndex] = useState(0);
    const [loading, setLoading] = useState(false);
    // Function to handle Snackbar opening
    const handleSnackbarOpen = (message, severity) => {
      setSnackbarMessage(message);
      setSnackbarSeverity(severity);
      setOpenToast(true);
    };
  
    const [editItem, setEditItem] = useState({});
      const [modalMode, setModalMode] = useState('');
    //  modalMode
    const handleEditModalOpen = (id, name, duration, packageAmount, admissionValue) => {
        setModalMode('edit');
        setEditItem({
          id: id,
          name: name,
          duration: duration,
          packageAmount: packageAmount,
          admissionValue: admissionValue
        });
        setField(id)
        setField1(name || '');
        setField2(duration || '');
        setField3(packageAmount || '');
        setField4(admissionValue || '');
       setaddmodalopen(true); // Open the edit modal
      };
      
      const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);
      const [status, setstatus] = useState('');
    const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
    const [openToast, setOpenToast] = useState(false);
    const [addmodalopen, setaddmodalopen] = useState(false);
    const [field, setField] = useState('');
    const [field1, setField1] = useState('');
    const [field2, setField2] = useState('');
    const [field3, setField3] = useState('');
    const [localrole] = useState(() => {
      try {
        return JSON.parse(localStorage.getItem("userdata"))?.role || "";
      } catch {
        return "";
      }
    });
    const [field4, setField4] = useState('');
    const [openConfirmation, setOpenConfirmation] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const handleToggle = (id,status) => {
    setOpenConfirmation(true);
   const newStatus = status === 1 ? 0 : 1;
  setstatus(newStatus);
  setDeleteConfirmationId(id);
  setIsActive(newStatus === 0);

  };

  const handleConfirm = async() => {
    // setIsActive(!isActive);
    // setOpenConfirmation(false);

    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; 
     
      
        const res = await StatusTrainerPackage(userToken,userId,status, deleteConfirmationId);

        if (res.code == "200") {
            handleSnackbarOpen(res.message, 'success');
            setIsActive(!isActive);
            setOpenConfirmation(false);
            setOpenDeleteConfirmation(false);
            fetchData();
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
  };

  const handleCancel = () => {
    setOpenConfirmation(false);
  };

    const handleaddOpen = () => {
        setModalMode('add');
        setaddmodalopen(true);
    };
  
    const handleaddClose = () => {
      setField1(''); 
      setField2('');
      setField3('');
      setFormSubmitted(false);
        setaddmodalopen(false);
    };
  
    

    const [age, setAge] = React.useState('');
  
    const handleChange = (event) => {
      setAge(event.target.value);
    };
  
    const mediaQueryVar = useMediaQuery(
      json2mq({
        minWidth: 600,
      })
    );

    const handleDelete = (id) => {
        handleClose();
        setDeleteConfirmationId(id);
        setOpenDeleteConfirmation(true,id);
      };
    
      const handleConfirmDelete =async (id) => {
        // setSnackbarMessage('package deleted successfully');
        // setSnackbarSeverity('error');
        // setOpenDeleteConfirmation(false);
        // setOpenToast(true); // Show toast message

        if (deleteConfirmationId !== null) {
         
            try {
                const userData = localStorage.getItem("userdata");
                const userDataObj = JSON.parse(userData);
                const userToken = userDataObj.token;
                const userId = userDataObj.id; 
             
              
                const res = await DeleteTrainerPackage(userToken, userId, deleteConfirmationId);
        
                if (res.code == "200") {
                    handleSnackbarOpen(res.message, 'success');
                    setOpenDeleteConfirmation(false);
                    fetchData();
                } else {
                    handleSnackbarOpen(res.message, 'error');
                    //  console.error(error); // Handle error
                }
            } catch (error) {
                console.error(error);
                // Handle errors
            }
        }
        };
      
    
      const handleCancelDelete = () => {
        setOpenDeleteConfirmation(false);
      };
      const handleToastClose = () => {
        setOpenToast(false);
      };
    
  
    
 
    
      const ITEM_HEIGHT = 48;
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };

 

   
const handleSubmit = async () => {
  setFormSubmitted(true); // Set form as submitted

  if (!field1 || !field2 || !field3 ) {
    // Prevent submission if any field is empty
    return;
  }
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
const userToken = userDataObj.token;
 
    if (modalMode === 'add') {
      try {
        const res = await createTrainerPackage(userToken, field1, field2, field3);
        if (res.code == "200") {
             setField1(''); 
             setField2('');
             setField3('');
            
            
            handleSnackbarOpen(res.message, 'success');
            fetchData();
          } else {
            handleSnackbarOpen(res.message, 'error');
         //   console.error(error); // Handle error
          }
      } catch (error) {
        console.error(error); // Handle error
      }
    } else if (modalMode === 'edit') {
        try {
            if (editItem) {
                const { id, name, duration, packageAmount, admissionValue } = editItem;
               
            const res = await UpdateTrainerPackage(id,userToken,  field1, field2, field3);
            if (res.code == "200") {
                 setField1(''); 
                 setField2('');
                 setField3('');
               
                
                handleSnackbarOpen(res.message, 'success');
                fetchData();
              } else {
                handleSnackbarOpen(res.message, 'error');
             //   console.error(error); // Handle error
              }
            }
          } catch (error) {
            console.error(error); // Handle error
          }
    }
    
    // Close the modal after submission
    handleaddClose();
  };
  const fetchData = async (value = '') => {
    setLoading(true);
    setHasMore(true);
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text
        const limit = 10; // Example limit
        const index = 0; // Example index
        const res = await retrieveTrainerPackage(userToken, userId, searchText, limit, index);

        if (res.code == "200") {
            setetchdatarow(res.load_data)
            console.log(res.load_data);
            setLoading(false);
        } else {
            // console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
};

  useEffect(() => {
   
    fetchData();
}, []); // This effect runs only once after the component mounts
const handleLoadMore = async () => {
    // Calculate the next index based on the number of items loaded so far
    const nextIndex = fetchdatarow.length
  
    const userData = localStorage.getItem("userdata");
    const userDataObj = JSON.parse(userData);
  
    try {
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const searchText = ''
      const limit = 10;
  
      const res = await retrieveTrainerPackage(userToken, userId, searchText, limit, nextIndex);
  
      if (res.code == "200") {
        // Append the newly loaded data to the existing data
        setetchdatarow((prevResults) => [...prevResults, ...res.load_data]);
  
        // Check if there are more results available
        if (res.load_data.length >= 0 && res.load_data.length < 10) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleSearchChange = (event, value) => {
    const searchText = value || ''; // If value is undefined or empty, set searchText to empty string
    // setSearchText(searchText);
    // Call fetchData function here with the updated searchText
    fetchData(searchText);
  };


const handleInputChange = async (value) => {
    if (value.length >= 3) {
    try {
        const userData = localStorage.getItem("userdata");
        const userDataObj = JSON.parse(userData);
        const userToken = userDataObj.token;
        const userId = userDataObj.id; // Assuming you have a userId in userdata
        const searchText = value; // Example search text
      
        const res = await AutocompleteTrainerPackage(userToken, userId, searchText);

        if (res.code == "200") {
            const names = res.data.map(item => item.name);
            setOptions(names);
        } else {
            handleSnackbarOpen(res.message, 'error');
            //  console.error(error); // Handle error
        }
    } catch (error) {
        console.error(error);
        // Handle errors
    }
}
};
  

  return (
    <div>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
      <Box sx={{ flex: 1 }}>
        <Autocomplete
          freeSolo
          id="package-search"
          disableClearable
          options={options}
          onInputChange={(event, value) => handleInputChange(value)}
          onChange={(event, value) => handleSearchChange(event, value)}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              sx={{
                maxWidth: { xs: '100%', sm: 300 },
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '8px',
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': {
                    borderColor: appColors.evergreen,
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: appColors.evergreen,
                  }
                }
              }}
              label="Search packages"
              InputProps={{
                ...params.InputProps,
                type: 'search',
              }}
            />
          )}
        />
      </Box>
      <Box>
        {localrole === 'admin' && (
        <Button
          variant="contained"
          startIcon={<ControlPointIcon />}
          onClick={handleaddOpen}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            background: `linear-gradient(to right, ${appColors.evergreen}, ${appColors.leaf})`,
            '&:hover': {
              background: `linear-gradient(to right, ${appColors.pine}, #60a5fa)`,
            },
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            px: 3
          }}
        >
          Add New
        </Button>
        )}
      </Box>
    </Box>


    <TableContainer
      component={Paper}
      sx={{
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
        borderRadius: '16px',
        overflowX: 'auto',
        background: '#ffffff',
        '@media (max-width: 600px)': {
          borderRadius: '12px',
        }
      }}
    >
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
          <CircularProgress sx={{ color: appColors.evergreen }} />
        </Box>
      ) : (
        <Table size="medium" aria-label="package table">
          <TableHead>
            <TableRow
              sx={{
                background: appColors.evergreen,
              }}
            >
              {["Name", "Duration (DAYS)", "Total Value", "Status", ...(localrole === 'admin' ? ["Action"] : [])].map(
                (header) => (
                  <TableCell
                    key={header}
                    align={header === "Action" ? "center" : "left"}
                    sx={{
                      color: '#ffffff',
                      fontWeight: 600,
                      fontSize: { xs: '0.875rem', sm: '1rem' },
                      py: 2,
                      '@media (max-width: 600px)': {
                        px: 1,
                        fontSize: '0.75rem',
                      }
                    }}
                  >
                    {header}
                  </TableCell>
                )
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {fetchdatarow.map((row, indexx) => (
              <TableRow
                key={indexx}
                sx={{
                  '&:nth-of-type(odd)': {
                    backgroundColor: '#f8fafc',
                  },
                  '&:hover': {
                    backgroundColor: '#f1f5f9',
                  },
                  transition: 'background-color 0.2s ease',
                }}
              >
                <TableCell sx={{ py: 2, '@media (max-width: 600px)': { px: 1 } }}>
                  <Typography sx={{ fontWeight: 500, color: '#1e293b' }}>
                    {row.name}
                  </Typography>
                </TableCell>
                <TableCell sx={{ '@media (max-width: 600px)': { px: 1 } }}>
                  <Typography sx={{ color: '#475569' }}>
                    {row.duration}
                  </Typography>
                </TableCell>
                <TableCell sx={{ '@media (max-width: 600px)': { px: 1 } }}>
                  <Typography sx={{ color: '#475569' }}>
                    ₹{row.package_amount}
                  </Typography>
                </TableCell>
                <TableCell sx={{ '@media (max-width: 600px)': { px: 1 } }}>
                  <Button
                    variant="contained"
                    size="small"
                    disabled={localrole !== 'admin'}
                    onClick={() => handleToggle(row.id, row.status)}
                    sx={{
                      backgroundColor: row.status === 1 ? '#22c55e' : '#ef4444',
                      '&:hover': {
                        backgroundColor: row.status === 1 ? '#16a34a' : '#dc2626',
                      },
                      textTransform: 'none',
                      minWidth: 'auto',
                      px: { xs: 1, sm: 2 },
                      py: 0.5,
                      '&.Mui-disabled': {
                        backgroundColor: row.status === 1 ? '#22c55e' : '#ef4444',
                        color: 'white',
                        opacity: 0.6,
                      },
                    }}
                  >
                    {row.status === 1 ? 'Active' : 'Inactive'}
                  </Button>
                </TableCell>
                {localrole === 'admin' && (
                <TableCell align="center" sx={{ '@media (max-width: 600px)': { px: 1 } }}>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                    <IconButton
                      size="small"
                      onClick={() => handleEditModalOpen(row.id, row.name, row.duration, row.package_amount)}
                      sx={{
                        color: appColors.evergreen,
                        '&:hover': { backgroundColor: '#e2e8f0' }
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleDelete(row.id)}
                      sx={{
                        color: '#ef4444',
                        '&:hover': { backgroundColor: '#fee2e2' }
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
             <div style={{ textAlign: "center", marginTop: "10px" }}>
             <Button
  variant="contained"
  color="primary"
  onClick={handleLoadMore}
 
  disabled={!hasMore || (fetchdatarow.length < 10 && fetchdatarow.length !== 0)}
  sx={{ fontWeight: 'bold', textTransform: 'none' }}
>
  {fetchdatarow.length === 0 || fetchdatarow.length < 10 ? 'No More Records' : 'Load More'}
</Button>


      </div>
      <Dialog 
        open={addmodalopen} 
        onClose={handleaddClose}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: { xs: '95%', sm: '600px' },
            width: '100%'
          }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: appColors.evergreen, 
          color: 'white',
          py: 2
        }}>
          {modalMode === 'add' ? 'Add New Package' : 'Edit Package'}
        </DialogTitle>
        <DialogContent sx={{ p: { xs: 2, sm: 3 }, mt: 2 }}>
          <Grid container spacing={3} sx={{mt:2}}>
            <Grid size={{xs:12}} >
              <TextField
                label="Package Name"
                fullWidth
                placeholder="Enter Package Name"
                value={field1}
                error={formSubmitted && !field1}
                helperText={formSubmitted && !field1 && "Package Name is required"}
                onChange={(e) => setField1(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  }
                }}
              />
            </Grid>
            <Grid size={{xs:12,md:6}}>
              <TextField
                label="Duration (Days)"
                type="number"
                fullWidth
                placeholder="Enter Duration"
                value={field2}
                error={formSubmitted && !field2}
                helperText={formSubmitted && !field2 && "Duration is required"}
                onChange={(e) => setField2(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  }
                }}
              />
            </Grid>
            <Grid size={{xs:12,md:6}}>
              <TextField
                label="Package Amount"
                type="number"
                fullWidth
                placeholder="Enter Amount"
                value={field3}
                error={formSubmitted && !field3}
                helperText={formSubmitted && !field3 && "Package Amount is required"}
                onChange={(e) => setField3(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': {
                      borderColor: appColors.evergreen,
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: appColors.evergreen,
                    }
                  }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            sx={{ 
              fontWeight: 'bold', 
              textTransform: 'none',
              color: appColors.evergreen
            }}  
            startIcon={<CancelIcon />}
            onClick={handleaddClose}
          >
            Cancel
          </Button>
          <Button 
            sx={{ 
              fontWeight: 'bold', 
              textTransform: 'none',
              background: `linear-gradient(to right, ${appColors.evergreen}, ${appColors.leaf})`,
              '&:hover': {
                background: `linear-gradient(to right, ${appColors.pine}, #60a5fa)`,
              }
            }} 
            startIcon={<CheckCircleIcon />}  
            onClick={handleSubmit} 
            variant="contained"
          >
            {modalMode === 'add' ? 'Submit' : 'Update'}
          </Button>
        </DialogActions>
      </Dialog>



      <Dialog 
        open={openDeleteConfirmation} 
        onClose={handleCancelDelete}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: { xs: '95%', sm: '400px' },
            width: '100%'
          }
        }}
      >
        <DialogTitle sx={{ bgcolor: '#fee2e2', color: '#dc2626', py: 2 }}>
          Delete Confirmation
        </DialogTitle>
        <DialogContent sx={{ pt: 2,mt:2  }}>
          <DialogContentText>
            Are you sure you want to delete this package?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            startIcon={<CancelIcon />} 
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
              color: appColors.evergreen
            }} 
            onClick={handleCancelDelete}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmDelete}  
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
              bgcolor: '#ef4444',
              '&:hover': {
                bgcolor: '#dc2626',
              }
            }} 
            variant="contained" 
            startIcon={<DeleteIcon />}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog 
        open={openConfirmation} 
        onClose={handleCancel}
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxWidth: { xs: '95%', sm: '400px' },
            width: '100%'
          }
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: isActive ? '#fee2e2' : '#dcfce7',
          color: isActive ? '#dc2626' : '#16a34a',
          py: 2
        }}>
          {isActive ? 'Deactivate' : 'Activate'}
        </DialogTitle>
        <DialogContent sx={{ pt: 2,mt:2  }}>
          <DialogContentText>
            {isActive
              ? 'Are you sure you want to deactivate this package?'
              : 'Are you sure you want to activate this package?'}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button 
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
              color: appColors.evergreen
            }} 
            startIcon={<CancelIcon />}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirm}
            sx={{
              fontWeight: 'bold',
              textTransform: 'none',
              background: `linear-gradient(to right, ${appColors.evergreen}, ${appColors.leaf})`,
              '&:hover': {
                background: `linear-gradient(to right, ${appColors.pine}, #60a5fa)`,
              }
            }} 
            variant="contained"
            startIcon={<CheckCircleIcon />}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
    </div>
  );
}

export default PtPackage;
